import script from "./RcStatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcStatusBadge.vue?vue&type=script&setup=true&lang=ts"

import "./RcStatusBadge.vue?vue&type=style&index=0&id=d6627962&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6627962"]])

export default __exports__